// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9932 ? "56da58dc" : chunkId) + "." + {"497":"723a0596aab445d0","5839":"2b40d4cecea444fc","9932":"d470736db857c782"}[chunkId] + ".js";
};